<template>
  <AppView title="解決方法">
    <main class="desk:flex desk:min-h-0 desk:flex-1 desk:flex-col desk:bg-white">
      <div class="desk:grid desk:min-h-0 desk:flex-1 desk:grid-cols-2 desk:items-start">
        <section
          class="hidden desk:flex desk:flex-col desk:justify-start desk:border-r desk:border-gray-100 desk:px-12 desk:py-12"
        >
          <p class="text-xs font-medium text-gray-400 desk:text-dove-gray">無法登錄</p>
          <h1 class="mt-2 text-3xl font-bold text-gray-900">微信無法登錄解決方法</h1>
          <p class="mt-3 text-sm leading-6 text-gray-500">
            微信登入沒有反應時，請改用電話號碼登入，或重設密碼。
          </p>
          <ol class="mt-8 space-y-7">
            <li class="flex items-start gap-3">
              <DeviceMobileIcon class="mt-0.5 h-6 w-6 flex-none text-primary" />
              <div>
                <p class="text-sm font-semibold text-gray-900">電話號碼登入</p>
                <p class="mt-0.5 text-xs leading-5 text-gray-400">
                  微信登入無反應時，使用電話號碼及密碼登入。
                </p>
              </div>
            </li>
            <li class="flex items-start gap-3">
              <LockClosedIcon class="mt-0.5 h-6 w-6 flex-none text-primary" />
              <div>
                <p class="text-sm font-semibold text-gray-900">重設密碼</p>
                <p class="mt-0.5 text-xs leading-5 text-gray-400">
                  忘記密碼時，按「忘記密碼」重新設定。
                </p>
                <nuxt-link
                  :to="localePath('/auth/forgot')"
                  class="mt-1 inline-block text-xs font-bold text-primary hover:underline"
                >前往重設密碼</nuxt-link>
              </div>
            </li>
            <li class="flex items-start gap-3">
              <SupportIcon class="mt-0.5 h-6 w-6 flex-none text-primary" />
              <div>
                <p class="text-sm font-semibold text-gray-900">聯絡客服</p>
                <p class="mt-0.5 text-xs leading-5 text-gray-400">
                  需要更多幫助時，請聯絡客服協助處理。
                </p>
              </div>
            </li>
          </ol>
          <nuxt-link
            :to="localePath('/auth/login')"
            class="btn mt-10 inline-flex h-12 w-full max-w-[400px] items-center justify-center text-base"
          >返回會員登入</nuxt-link>
        </section>

        <section class="min-w-0 desk:px-12 desk:py-10">
          <img
            v-if="!imgFailed"
            src="/imgs/help.png"
            alt="微信無法登錄解決方法"
            class="w-full desk:mx-auto desk:block desk:h-auto desk:max-w-[520px]"
            @error="imgFailed = true"
          />
          <p v-else class="px-5 py-10 text-center text-sm text-gray-400 desk:px-0">
            暫無說明圖片，請返回登入頁或聯絡客服。
          </p>
        </section>
      </div>
    </main>
  </AppView>
</template>

<script>
import {
  DeviceMobileIcon,
  LockClosedIcon,
  SupportIcon,
} from "@vue-hero-icons/outline";

export default {
  auth: false,
  components: {
    DeviceMobileIcon,
    LockClosedIcon,
    SupportIcon,
  },
  data() {
    return {
      imgFailed: false,
    };
  },
};
</script>

<style lang="scss" scoped></style>
